import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Users, Award, CheckCircle2, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const CTASection = () => {
  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-6">
        <div className="grid gap-8 md:grid-cols-2">
          {/* Looking for Talent Card */}
          <Card className="border-0 bg-gradient-hero text-primary-foreground shadow-elevated rounded-2xl transition-all duration-300 hover:scale-105 hover:shadow-[0_20px_60px_-15px_rgba(59,130,246,0.5)]">
            <CardContent className="p-8 md:p-10">
              <Users className="mb-6 h-12 w-12" />
              <h2 className="mb-4 text-3xl font-bold">
                Looking for Talent?
              </h2>
              <p className="mb-6 text-lg text-primary-foreground/90">
                Partner with us to find the perfect candidates for your organisation. From SMEs to national authorities, we deliver results.
              </p>
              <div className="mb-8 space-y-3">
                <div className="flex items-center gap-2">
                  <CheckCircle2 className="h-5 w-5 flex-shrink-0" />
                  <span>Permanent Placements</span>
                </div>
                <div className="flex items-center gap-2">
                  <CheckCircle2 className="h-5 w-5 flex-shrink-0" />
                  <span>Temporary Staff</span>
                </div>
                <div className="flex items-center gap-2">
                  <CheckCircle2 className="h-5 w-5 flex-shrink-0" />
                  <span>Flexible Solutions</span>
                </div>
              </div>
              <Link to="/contact">
                <Button 
                  size="lg"
                  className="bg-background text-foreground hover:bg-background/90"
                >
                  Contact Us
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </Link>
            </CardContent>
          </Card>

          {/* Find Your Next Role Card */}
          <Card className="border-border bg-card shadow-card rounded-2xl transition-all duration-300 hover:scale-105 hover:shadow-[0_20px_60px_-15px_rgba(59,130,246,0.5)]">
            <CardContent className="p-8 md:p-10">
              <Award className="mb-6 h-12 w-12 text-primary" />
              <h2 className="mb-4 text-3xl font-bold text-foreground">
                Find Your Next Role
              </h2>
              <p className="mb-6 text-lg text-muted-foreground">
                Discover exciting opportunities across the UK. We connect talented professionals with rewarding careers.
              </p>
              <div className="mb-8 space-y-3">
                <div className="flex items-center gap-2 text-foreground">
                  <CheckCircle2 className="h-5 w-5 flex-shrink-0 text-primary" />
                  <span>Free CV Review</span>
                </div>
                <div className="flex items-center gap-2 text-foreground">
                  <CheckCircle2 className="h-5 w-5 flex-shrink-0 text-primary" />
                  <span>Career Guidance</span>
                </div>
                <div className="flex items-center gap-2 text-foreground">
                  <CheckCircle2 className="h-5 w-5 flex-shrink-0 text-primary" />
                  <span>Exclusive Opportunities</span>
                </div>
              </div>
              <Link to="/jobs">
                <Button 
                  size="lg"
                  className="bg-gradient-hero text-primary-foreground hover:opacity-90"
                >
                  Browse Jobs
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
